import CompetitorAlternativePage from '@/components/Pages/CompetitorAlternativePage';
import { CHATHUB_ALTERNATIVE } from '@/constants/competitorAlternatives';

export default function ChatHubAlternativePage() {
  return (
    <CompetitorAlternativePage
      title="ChatHub Alternative — Multi-Model AI App"
      description="A ChatHub alternative: GPT, Claude, Gemini, and Arya in one private Gab AI workspace — with images, video, music, and apps."
      canonical="/chathub-alternative"
      keywords="ChatHub alternative, alternative to ChatHub, ChatHub AI alternative, better than ChatHub, ChatHub competitor, apps like ChatHub, free ChatHub alternative, best ChatHub alternative"
      page={CHATHUB_ALTERNATIVE}
    />
  );
}
